export const linkType = {
    article: 'doc',
    slide: 'slide',
    video: 'phvideo',
    special: 'topic3',
    short: 'short',
    hotEvent: 'hotspotlist',
    miniVideo: 'videoshortimg',
};
